<template>
    <div>
        <el-row style="display: flex;margin-bottom: 10px;">
            <el-col :span="14" >
                <el-select v-model="form.projectId" @change="theProjectAllChange" size="small" filterable clearable
                    placeholder="请选择项目" v-if="theProjectId == 0">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
                <el-button v-if="uploadTemStatisticDepartment" @click=" $form('uploadTemStatisticDepartment'), tabledataAll = [], row = {}"
                    size='small' type="primary" style="float:right;margin-right: 20px;" icon='el-icon-circle-plus'>批量导入
                </el-button>
            </el-col>

        </el-row>
        <div>
            <myform :viewobj='{

                updateTemStatisticDepartment: ["修改战队数据", "el-icon-edit-outline"],
                $succeed$: getTemStatisticDepartmentList
            }'>
                <hide slot='projectId' />
                <hide slot='ytsdId' />

            </myform>
            <mytable :tableColums='tableColums_getTemStatisticDepartmentList' api='getTemStatisticDepartmentList'
                xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
            </mytable>
        </div>
        <myform view.uploadTemStatisticDepartment="批量导入" @close='$form("uploadTemStatisticDepartment", "hide")'>
            <el-row>
                <el-col :span="4" style="min-width:100px;">
                    <el-button type="primary" @click="toDownExcel">下载<i
                            class="el-icon-download el-icon--right"></i></el-button>
                </el-col>
                <el-col :span="20">
                    <el-upload ref="uploadAll" action="#" :limit="1" :auto-upload="false" :show-file-list="true"
                        :on-change="onChangeContent">
                        <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                </el-col>
            </el-row>
            <el-table :data="tabledataAll" v-if="(tabledataAll || '').length > 0" max-height="400">
                <el-table-column prop="status" label="状态" width="120">
                </el-table-column>
                <el-table-column prop="statusMsg" label="原因" width="120">
                </el-table-column>
                <el-table-column prop="ytsdName" label="战队名称">
                </el-table-column>
                <el-table-column prop="ytsdOne" label="区县续费条数（客户经理）">
                </el-table-column>
                <el-table-column prop="ytsdTwo" label="区县企宽7月到期总量（客户经理）">
                </el-table-column>
                <el-table-column prop="ytsdThree" label="区县续费条数（网格）">
                </el-table-column>
                <el-table-column prop="ytsdFour" label="区县企宽到期总量（网格）">
                </el-table-column>
                <el-table-column prop="ytsdFive" label="区县续费条数（累计）">
                </el-table-column>
                <el-table-column prop="ytsdSix" label="区县企宽到期总量（累计）">
                </el-table-column>

            </el-table>
            <!-- <div style="width:100%; margin: 60px auto 20px;text-align: right;">
                <el-button @click="bulkImportClose">取 消</el-button>
                <el-button type="success" @click="bulkImportClick">确定导入</el-button>
            </div> -->
        </myform>
    </div>
</template>
  
<script>
import myhttp from '../../utils/myhttp';
import qs from 'qs';
import axios from 'axios';
export default {
    data() {
        return {
            baseUrl: $Api.baseUrl_online,
            tabledataAll:[],
            theProjectId: 0,
            value: '',
            form: {
                projectId: '',
                yasDate: '',
                yasCommand: '',
                yasTimeStart: '',
                yasTimeEnd: '',
                yasDes: '',
            },
            tableColums_getTemStatisticDepartmentList: {
                $selection: false,

                // oiType: '限制字段key',

                ytsdName: '战队名称',
                ytsdOne: '区县续费条数（客户经理）',
                ytsdTwo: '区县企宽7月到期总量（客户经理）',
                ytsdThree: '区县续费条数（网格）',
                ytsdFour: '区县企宽到期总量（网格）',
                ytsdFive: '区县续费条数（累计）',
                ytsdSix: '区县企宽到期总量（累计）',


                $operation: [
                    '操作', 200,
                    this.updateTemStatisticDepartment && `@text: 编辑#success
               @click: $form("updateTemStatisticDepartment",$row)
              `,
            //         this.deleteProjectPropSpecialist && `@text: 删除#danger
            //    @click: _confirm('确定要删除该填写项约束吗?')
            //            .trigger('deleteProjectPropSpecialist',{yppsId:$row.yppsId})
            //            .trigger('getTemStatisticDepartmentList',{projectId:form.projectId})
            //   `,
                ],
            }
        }
    },
    methods: {
        openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        doupload: async function (file) {
            let param = new FormData(); // 创建form对象
            param.append("file", file); // 通过append向form对象添加数据
            if (this.row && this.row.projectId) {
                param.append("projectId", this.row.projectId);
            }
            console.log(param)
            const loading = $Loading();
            const responseData = await myhttp.postFileUsers("/trainingmsg/tem-statistic-department/uploadTemStatisticDepartment", param);
            loading.close();
            if (responseData.data.result == "success") {
                this.$message({
                    type: "success",
                    message: "上传成功!"
                });
            } else {
                this.$message({
                    type: "error",
                    message: "上传失败!"
                });
            }
            return responseData
        },
        async onChangeContent(files, fileList) {
            const table = await this.doupload(files.raw);
            this.tabledata = table.data.data.data.sysImportTem;
            this.tabledataAll = table.data.data.data.resultList;
            //    this.getUserTargetList();
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();  //清空文件
            }
            if (this.$refs.uploadAll) {
                this.$refs.uploadAll.clearFiles();  //清空文件
            }
        },
        toDownExcel() {
            myhttp.downloadFile("https://trainapp.aojuai.com/trainai/excel/temdepartment.xlsx", "临时战队.xlsx");
        },
        myform(submit, Myformdata) {
            Myformdata.projectId = this.form.projectId;
            submit();
        },
        theProjectAllChange(e) {
            if (e == '') {
                return this.form.projectId = e;
            }
            this.form.projectId = e;
            this.getTemStatisticDepartmentList({ projectId: this.form.projectId })
        },
    },
    created() {
        this.getProjectList({
            pageSize: 0
        });

        this.theProjectId = A.local("$projectId");
        if (this.theProjectId != 0) {
            this.form.projectId = this.theProjectId;
        }
        this.getTemStatisticDepartmentList({ projectId: this.form.projectId })
    },
}
</script>
  
<style scoped></style>
  


// WEBPACK FOOTER //
// src/views/data/ephemeral.vue